import * as THREE from "three";

export function laplacianFilter(
    vertices,
    prevVertices,
    vertexIndicesToSmooth,
    neighbors
) {
    for (let i of vertexIndicesToSmooth) {
        let vertexNeighbors = neighbors[i];
        let average = new THREE.Vector3();

        if (!vertexNeighbors) {
            continue;
        }

        for (let j of vertexNeighbors) {
            let neighbor = new THREE.Vector3(
                prevVertices[j * 3],
                prevVertices[j * 3 + 1],
                prevVertices[j * 3 + 2]
            );
            average.add(neighbor);
        }
        average.divideScalar(vertexNeighbors.size);

        vertices[3 * i + 0] = average.x;
        vertices[3 * i + 1] = average.y;
        vertices[3 * i + 2] = average.z;
    }
}

export function laplacianHCFilter(
    originalVertices,
    vertices,
    prevVertices,
    vertexIndicesToSmooth,
    neighbors,
    alpha = 0.1,
    beta = 0.4
) {
    let differences = [];
    for (let i of vertexIndicesToSmooth) {
        const vertex = new THREE.Vector3(
            vertices[3 * i + 0],
            vertices[3 * i + 1],
            vertices[3 * i + 2]
        );
        const originalVertex = new THREE.Vector3(
            originalVertices[3 * i + 0],
            originalVertices[3 * i + 1],
            originalVertices[3 * i + 2]
        );
        const prevVertex = new THREE.Vector3(
            prevVertices[3 * i + 0],
            prevVertices[3 * i + 1],
            prevVertices[3 * i + 2]
        );

        differences[i] = vertex.sub(
            originalVertex
                .multiplyScalar(alpha)
                .add(prevVertex.multiplyScalar(1.0 - alpha))
        );
    }

    for (let i of vertexIndicesToSmooth) {
        let vertexNeighbors = neighbors[i];
        let averageDiff = new THREE.Vector3(0, 0, 0);

        if (!vertexNeighbors) {
            continue;
        }

        for (let j of vertexNeighbors) {
            let neighbor = differences[j] || new THREE.Vector3();
            averageDiff.add(neighbor);
        }

        const vertex = new THREE.Vector3(
            vertices[3 * i + 0],
            vertices[3 * i + 1],
            vertices[3 * i + 2]
        );
        const difference = differences[i].clone();
        const newVertex = vertex.sub(
            difference
                .multiplyScalar(beta)
                .add(
                    averageDiff.multiplyScalar(
                        (1.0 - beta) / vertexNeighbors.size
                    )
                )
        );

        vertices[3 * i + 0] = newVertex.x;
        vertices[3 * i + 1] = newVertex.y;
        vertices[3 * i + 2] = newVertex.z;
    }
}
